import tw from 'twin.macro';
import { Button, FilterItemWrapper, InputDateRange } from '.';
import { ButtonColor, ButtonSize } from '../enums';
import strings from '../language/Swedish';
import { FilterDateItem } from '../types/dataTypes';
import styled from 'styled-components';

const CenteredButtonContainer = styled.div`
  ${tw`flex justify-center items-center w-full`}
`;

interface Props<TFilter> {
  filterData: TFilter;
  filterItem: FilterDateItem;
  handleDateReset: (id: string, value?: boolean) => void;
  handleMinMaxChange: (id: string, value: Date) => void;
  isMobileLandscape?: boolean;
}

const DateItemFilter = <TFilter, TFilterParams extends keyof TFilter>({
  filterData,
  filterItem: { label, icon, minId, maxId },
  handleDateReset,
  handleMinMaxChange,
  isMobileLandscape,
}: Props<TFilter>) => {
  const filterValuesMin = filterData[minId as TFilterParams] as Date | null;
  const filterValuesMax = filterData[maxId as TFilterParams] as Date | null;

  const isActive = filterValuesMin !== null && filterValuesMax !== null;

  return (
    <FilterItemWrapper
      label={label}
      icon={icon}
      handleReset={() => {
        handleDateReset(minId);
        handleDateReset(maxId);
      }}
      isActive={isActive}
      isMobileLandscape={isMobileLandscape}>
      {isActive ? (
        <InputDateRange
          id={`${minId}- ${maxId}`}
          minId={minId}
          maxId={maxId}
          value={[filterValuesMin, filterValuesMax]}
          handleValueChange={handleMinMaxChange}
        />
      ) : (
        <CenteredButtonContainer>
          <Button
            color={ButtonColor.primary}
            size={ButtonSize.large}
            onClick={() => {
              handleDateReset(minId, true);
              handleDateReset(maxId, true);
            }}>
            {' '}
            {strings.filter.activate}
          </Button>
        </CenteredButtonContainer>
      )}
    </FilterItemWrapper>
  );
};

export default DateItemFilter;
